import { DemographicAgeGroupDto } from '@/core/api/dtos/response/demographicAgeGroup/demographicAgeGroup'
import { DemographicAgeGroup } from '@/core/api/entities/demographicAgeGroup'

export class DemographicAgeGroupMapper {
	public static toEntity(dto: DemographicAgeGroupDto): DemographicAgeGroup {
		return new DemographicAgeGroup(dto)
	}

	public static toDTO(entity: DemographicAgeGroup): DemographicAgeGroupDto {
		return entity.key
	}

	public static toEntities(
		dtos: DemographicAgeGroupDto[]
	): DemographicAgeGroup[] {
		return dtos.map(this.toEntity)
	}
}
